export const REQUEST_ASSETS = 'REQUEST_ASSETS';
export const RECEIVE_ASSETS = 'RECEIVE_ASSETS';

export const receiveAssets = (data) => {
    return (dispatch) => {
        dispatch({
            type      : RECEIVE_ASSETS,
            payload   : data,
            receivedAt: Date.now()
        });
    };
};


// WEBPACK FOOTER //
// ./src/actions/AssetsAction.js